export const orgStructureApi = (client) => ({
    /// Read-only — resolves every row against existing data and reports
    /// new/existing/updated counts and names per level. Writes nothing.
    previewImport: (rows, updateExisting) => client.post('/api/v1/org-structure/import/preview', { rows, updateExisting }).then((r) => r.data),
    /// Transactional, all-or-nothing — re-resolves the same rows inside
    /// a transaction and commits. A row-level failure anywhere rolls
    /// back everything, same as sites/parts bulk-create.
    ///
    /// `updateExisting` (off by default): when true, a row that MATCHES
    /// an existing customer/site/location by name also patches that
    /// record's fields from the file — a blank cell never clears an
    /// existing value, only a differing non-blank cell overwrites it.
    /// When false, matching only resolves structural placement; an
    /// existing record's fields are never touched.
    commitImport: (rows, updateExisting) => client.post('/api/v1/org-structure/import/commit', { rows, updateExisting }).then((r) => r.data),
});
//# sourceMappingURL=org-structure.js.map